import { render } from "./SearchTruckModal.vue?vue&type=template&id=7ba87b6f"
import script from "./SearchTruckModal.vue?vue&type=script&lang=js"
export * from "./SearchTruckModal.vue?vue&type=script&lang=js"
script.render = render

export default script